import { render } from "./DiscourseAnnotations.vue?vue&type=template&id=4153915f&scoped=true"
import script from "./DiscourseAnnotations.vue?vue&type=script&lang=js"
export * from "./DiscourseAnnotations.vue?vue&type=script&lang=js"

import "./DiscourseAnnotations.vue?vue&type=style&index=0&id=4153915f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4153915f"]])

export default __exports__